import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { toJS } from 'mobx'
import { Radio, Button, Rate } from 'hljd'
import { Input } from 'hlj-components'
import ImgGallery from '@common/ImgGallery'
import styles from './style.module.less'
import store from '../store'
import twemoji from 'twemoji'
import cls from 'classnames'
import TipModal from '../TipModal'
import { replaceEmojiToImg } from '@hlj/hlj-utils'
import { PreviewModal } from 'hlj-components'
import SlideModal from '@common/SlideModal'

const RadioGroup = Radio.Group

@observer
export default class extends Component {
  UNSAFE_componentWillMount() {
    store.init()
    if (store.kind == 'question') {
      store.getAppealInfo_question()
    } else {
      store.getAppealInfo()
    }
  }
  getVideoBox = comment_video => {
    if (
      comment_video &&
      comment_video.cover_path &&
      comment_video.status == 1
    ) {
      return (
        <div className={styles.video}>
          <img
            className={styles.img}
            src={`${comment_video.cover_path}?imageView2/1/w/120/h/120`}
          />
          <div className={styles['video-bg']} />
          <img
            className={styles.icon}
            onClick={store.showPreviewModal(comment_video.path)}
            src="http://qnm.hunliji.com/o_19uji7qatf001r4udmj10e28mu32.png"
          />
        </div>
      )
    }
    return null
  }
  render() {
    const {
      reason,
      content,
      showUpload,
      photos,
      author,
      comment_photos,
      comment_video,
      created_at,
      rating,
      content_appeal,
      ratingText,
      content_question,
      created_at_question,
      nick_question,
      isModalShow,
      preViewPath,
      prew,
      initialPrew,
      imglist
    } = store
    let operation = (
      <div className={styles.opration}>
        <ul>
          <li>+</li>
          <li>添加图片</li>
          <li>
            还可添加<span style={{ color: '#6e9df0' }}>
              {9 - photos.length}
            </span>张
          </li>
        </ul>
      </div>
    )

    let twemojiContent = content_appeal
    let videoBox = this.getVideoBox(comment_video)
    let photoBox = (comment_photos || []).map(({ photo_path }, index) => (
      <img
        key={index}
        src={photo_path + '?imageView2/1/w/120/h/120'}
        style={{ marginRight: 5, cursor: 'pointer', marginBottom: '5' }}
        onClick={store.prewImg(index, comment_photos)}
      />
    ))

    return (
      <div>
        <div className={styles.reasonWrap}>
          <div className={styles.selectReason}>
            <p>
              请选择申诉理由
              <span className={styles.one}>(单选)</span>
            </p>
            <RadioGroup value={reason} onChange={store.changeReason}>
              <Radio value="恶意诋毁">
                <span style={{ verticalAlign: 'middle' }}>恶意诋毁</span>
              </Radio>
              <Radio value="广告">
                {' '}
                <span style={{ verticalAlign: 'middle' }}>广告</span>
              </Radio>
              <Radio value="色情">
                <span style={{ verticalAlign: 'middle' }}>色情</span>
              </Radio>
              <Radio value="辱骂脏话">
                <span style={{ verticalAlign: 'middle' }}>辱骂脏话</span>
              </Radio>
              <Radio value="其他">
                <span style={{ verticalAlign: 'middle' }}>其他</span>
              </Radio>
            </RadioGroup>
          </div>
          <div className={styles.inputReason}>
            <Input
              maxText={200}
              type="textarea"
              style={{ height: 160, padding: 20 }}
              placeholder="请填写您认为评论不当的原因，方便平台方判断，30-200字以内"
              inputChange={store.changeContent}
              value={content}
            />
          </div>
          <div className={styles.upload}>
            <p style={{ marginBottom: 20 }}>上传图片凭证：</p>
            <ImgGallery
              max={9}
              style={{ marginLeft: -5 }}
              operation={operation}
              imgList={photos}
              keyField="image_path"
              showUpload={showUpload}
              onOk={store.uploadOk}
              onRemove={store.removeImg}
            />
            <p>举证图片必须上传，需上传1-9张图片</p>
          </div>
          <div className={styles.appeal}>
            <p className={styles.title}>申诉内容：</p>
            {store.kind == 'question' ? (
              <div className={styles.item}>
                <div>
                  <p
                    className={cls({
                      [styles.question]: true,
                      [styles.answer]: store.type == '2'
                    })}
                  >
                    {content_question}
                  </p>
                  <p className={styles.answer}>
                    <span>{nick_question}</span>
                    <span>{created_at_question}</span>
                  </p>
                </div>
              </div>
            ) : (
              <div style={{ padding: '0px 20px' }}>
                <p className={styles.nameWrap}>
                  <span className={styles.name}>{author.nick}</span>
                  <span className={styles.time}>{created_at}</span>
                </p>
                <p
                  className={styles.comment}
                  dangerouslySetInnerHTML={{
                    __html: twemoji.parse(replaceEmojiToImg(twemojiContent))
                  }}
                />
                {store.type == 1 && (
                  <div>
                    <div style={{ width: '400px' }}>
                      {videoBox} {photoBox}
                    </div>
                    <div>
                      <Rate value={+rating} disabled />
                      <i className={styles.out}>{ratingText}</i>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
        <div className={styles.submit}>
          <Button
            type="primary"
            style={{ width: 240, height: 46, fontSize: 18 }}
            disabled={!reason}
            onClick={store.submitAppeal}
          >
            提交申诉
          </Button>
        </div>

        <TipModal
          width={250}
          isShow={isModalShow}
          status_text="提交成功"
          tip="我们将尽快为您核实并处理同时感谢您对婚礼纪的支持"
        />

        {prew ? (
          <SlideModal
            keyField="photo_path"
            slideHeight="600"
            suffix="imageView2/2/w/530/h/600"
            visible={prew}
            imgList={toJS(imglist)}
            initialSlide={initialPrew}
            onCancel={store.prewImg(0)}
          />
        ) : null}

        <PreviewModal visible={preViewPath} onCancel={store.showPreviewModal()}>
          {preViewPath && (
            <video
              style={{ width: '800px' }}
              src={`${preViewPath}?avthumb/mp4/vcodec/libx264`}
              controls
            />
          )}
        </PreviewModal>
      </div>
    )
  }
}
